<template>

    <div>
        <el-tabs v-model="activeName">
            <el-tab-pane v-for="group in groups" :label="group.name" :name="group.name">
                <el-checkbox-group disabled v-model="checkedRescIds">
                    <div v-for="appResc in group.sysRescs">
                        <div class="content-caption dashed">
                            <label @change="handleCheckAllChange(appResc)">
                                <el-checkbox disabled :label="appResc.rescId">
                                    <span class="'font-gray2 mr5'">{{appResc.rescName}}</span>
                                    <span>（<span class="font-gray3">{{appResc.rescDesc}}</span>）</span>
                                </el-checkbox>
                            </label>
                        </div>
                        <div class="switch-list clearfix ml15">
                            <el-checkbox-group disabled v-model="appResc.checkedActions">
                                <div v-for="action in appResc.actionList" class="switch-item ellipsis-1" style="width: auto;margin-right: 30px">
                                    <el-checkbox disabled :label="action.code">
                                        <span>{{action.name}}</span>
                                    </el-checkbox>
                                </div>
                            </el-checkbox-group>
                        </div>
                    </div>
                </el-checkbox-group>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'

    import comnApi from '../../api/comn';
    import merchtAllApi from '../../api/merchtAll'

    export default {
        name: 'swb-tpl-com-role-resc-for-mob-app',
        props: ['roleId', 'mobAppRoleCode', 'scopeCode'],
        data: function () {
            return {
                checkedRescIds: [],
                appRescs: [],
                sysRescAction: {},
                ownRescList: [],
                theLoading: null,
                groups: [],
                activeName: null
            }
        },
        created: function () {
            //获取已关联的资源
            this.getTplComRoleRescListForMobApp();
        },
        methods: {
            getTplComRoleRescListForMobApp(){
                let self = this;
                self.theLoading = MsgBox.loading();
                merchtAllApi.getTplComRoleRescListForMobApp(self.roleId, function (result) {
                    if(result.type == 'info') {
                        self.ownRescList = result.data;
                        self.getMobAppRoleRescListByCode();
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getMobAppRoleRescListByCode(){
                let self = this;
                let postData = {};
                postData.code = self.mobAppRoleCode;
                postData.scopeCode = self.scopeCode;
                comnApi.getMobAppRoleRescListByCode(postData, function (result) {
                    self.theLoading.close();
                    if(result.type == 'info') {
                        let appRescs = result.data;
                        //
                        if(appRescs != null && appRescs.length > 0) {
                            for(let i = 0; i < appRescs.length; i++) {
                                let appResc = appRescs[i];
                                appResc.checkedActions = [];
                                self.ownRescList.forEach(function (ownResc) {
                                    if(appResc.rescId == ownResc.rescId) {
                                        self.checkedRescIds.add(appResc.rescId);
                                        if(ownResc.actionList != null) {
                                            appResc.checkedActions = ownResc.actionList;
                                        }

                                    }
                                });
                            }
                        }
                        self.appRescs = appRescs;
                        self.initGroup(appRescs);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            initGroup(sysRescs){
                let groups = [];
                let groups_serv_dispatching = [
                    {
                        name: '请求工单',
                        checked: false,
                        indeterminate: false,
                        sysRescs: [],
                        scope: [
                            "dispatWorkOrderList",
                            "servcOrderEval",
                            "engineerRepairRec",
                            "servcReqVoucher",
                            "proxyWorkVoucher"
                        ]
                    },
                    {
                        name: '调度管理',
                        checked: false,
                        indeterminate: false,
                        sysRescs: [],
                        scope: [
                            "engineerDefList",
                            "servcOrderList",
                            "transCauseList",
                            "engineerList",
                            "engiDayOffList"
                        ]
                    },
                    {
                        name: '销售管理',
                        checked: false,
                        indeterminate: false,
                        sysRescs: [],
                        scope: [
                            "servcCatChargeItemList",
                            "msuList",
                            "proxyServcOrder",
                            "bizRelList"
                        ]
                    },
                    {
                        name: '配件管理',
                        checked: false,
                        indeterminate: false,
                        sysRescs: [],
                        scope: [
                            "accStockList",
                            "accIoRecord",
                            "shopAccApp",
                            "shopAccAppForMercht",
                            "shopAccTurn",
                            "shopAccTurnForMercht",
                            "shopAccStockList",
                            "shopAccIoRecord",
                            "staffAccApp",
                            "staffAccTurn"
                        ]
                    },
                    {
                        name: '人事',
                        checked: false,
                        indeterminate: false,
                        sysRescs: [],
                        scope: [
                            'roleList',
                            'staffManage',
                            'comStaffManage',
                        ]
                    }
                ];
                let groups_serv_engineer = [{
                    name: "服务工程师",
                    checked: false,
                    indeterminate: false,
                    sysRescs: [],
                    scope: [
                        "accAppturnVoucher",
                        "staffAccStockList",
                        "workOrder",
                        "myWorkOrderList",
                        "proxiedReqList",
                        "createWorkVoucher",
                        "servManagWeiXin",
                        "grabList"
                    ]
                },
                    {
                        name: '人事',
                        checked: false,
                        indeterminate: false,
                        sysRescs: [],
                        scope: [
                            'roleList'
                        ]
                    }];
                if(this.mobAppRoleCode == "dispatching") {
                    groups = groups_serv_dispatching;
                } else if(this.mobAppRoleCode == "engineer") {
                    groups = groups_serv_engineer;
                }
                let otherGroup = {
                    name: "其他",
                    checked: false,
                    indeterminate: false,
                    sysRescs: [],
                    scope: []
                };
                console.log(sysRescs);
                sysRescs.forEach(function (sysResc) {
                    let currGroup = groups.find(function (group) {
                        return group.scope.indexOf(sysResc.pattern) > -1;
                    });
                    if(currGroup == null) {
                        otherGroup.scope.push(sysResc.pattern);
                        otherGroup.sysRescs.push(sysResc);
                    } else {
                        currGroup.sysRescs.push(sysResc);
                    }
                });
                if(otherGroup.scope.length > 0) {
                    groups.push(otherGroup);
                }
                console.log(groups);
                this.activeName = groups[0].name;
                this.groups = groups;
            },
            handleCheckAllChange(appResc) {
                let index = this.checkedRescIds.indexOf(appResc.rescId);
                if(index > -1) {
                    appResc.checkedActions = appResc.actionList.pluck("code");
                } else {
                    appResc.checkedActions = [];
                }
                //
                let currItem = this.appRescs.find(function (item) {
                    return item.rescId == appResc.rescId;
                });
                currItem.checkedActions = appResc.checkedActions;
                this.appRescs = Utils.merge([], this.appRescs);
            },
            getDlgResult(){
                let roleId = this.roleId;
                let resultData = {};
                resultData.roleId = roleId;
                resultData.tplComRoleRescs = [];

                let checkedRescIds = this.checkedRescIds;
                this.appRescs.forEach(function (appResc) {
                    if(checkedRescIds.indexOf(appResc.rescId) >= 0) {
                        let tplComRoleResc = {
                            tplRoldId: roleId,
                            rescId: appResc.rescId,
                            actionList: appResc.checkedActions
                        };
                        resultData.tplComRoleRescs.add(tplComRoleResc);
                    }
                });

                let result = {};
                result.data = resultData;
                result.type = 'info';
                return result;
            }
        }
    }
</script>




// WEBPACK FOOTER //
// src/compo/comn/TplComRoleRescForMobApp.vue